import { render, staticRenderFns } from "./AllocationUnitDetailsInvoices.vue?vue&type=template&id=e2752158&"
import script from "./AllocationUnitDetailsInvoices.vue?vue&type=script&lang=js&"
export * from "./AllocationUnitDetailsInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports